import { connect } from 'react-redux'
import { getPostDischarges12mList } from '../actions/actions-postdischarges'
import { getProgramsAssignedToLoginList } from '../actions/actions-programs'
import PostDischarges12m from '../views/PostDischarges/postdischarges12m'
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    postdischarges: state.postdischargesR.dataList,
    programsAssigned: state.programsR.programsassignedtologin
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getPostDischarges: loginID => {
      dispatch(getPostDischarges12mList(loginID))
    },
    getProgramsAssignedToLoginList: id => {
      dispatch(getProgramsAssignedToLoginList(id))
    }
  }
}
const PostDischarge12mListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PostDischarges12m)
export default PostDischarge12mListContainer
